import React from 'react';
import { Row } from 'antd';
import { SchemaCollection } from 'types/dt-graphql-apollo-v2';
import { EmptyCard } from 'components/CardItem/EmptyCard';
import { InfoMessage } from 'components';
import { useAccessControl } from 'hooks/useAccessControl';
import { groupedPermissionsList } from 'store/permissions';
import { SchemaCard } from './components/SchemaCard';

type SchemaListTypes = {
  schemaCollections: SchemaCollection[];
  onCreateNewSchema: VoidFunction;
};

export const SchemaCardsList = ({
  schemaCollections,
  onCreateNewSchema,
}: SchemaListTypes) => {
  const hasAccess = useAccessControl();
  const canCreateSchemaCollection = hasAccess(
    groupedPermissionsList.CAN_CREATE_SCHEMA_COLLECTION
  );

  if (!schemaCollections || schemaCollections.length === 0) {
    if (canCreateSchemaCollection) {
      return (
        <EmptyCard title="Add Schema" onCreateNewItem={onCreateNewSchema} />
      );
    }
    return <InfoMessage type="Error" title="No schemas found" />;
  }

  const sortByName = (collections: SchemaCollection[]) =>
    [...collections].sort((a, b) => (a.name < b.name ? -1 : 1));

  return (
    <Row style={{ gap: '2rem' }}>
      {sortByName(schemaCollections).map((schemaCollection) => (
        <SchemaCard schemaCollection={schemaCollection} />
      ))}
    </Row>
  );
};
